import moment from 'moment-timezone';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

import TimeSlotConfirmationModal from './TimeSlotConfirmationModal';

import { TIME_OF_DAY_FORMAT } from '../../../utils/dateTime';

import { Button } from '@vivaahealth/design-system';

import * as api from '../../../api';

import styles from '../index.module.css';

interface Props {
  timeSlots: api.EhrTimeSlot.EhrTimeSlot[];
  timezone: string;
  onAppointmentSelected: (appointment: api.EhrTimeSlot.EhrTimeSlot) => void;
}

const TimeSlots: React.FC<Props> = ({
  timeSlots,
  timezone,
  onAppointmentSelected,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedSlot, setSelectedSlot] =
    useState<api.EhrTimeSlot.EhrTimeSlot | null>(null);
  const { authenticationCode } = useParams<{ authenticationCode: string }>();

  const closeModal = (
    auditLog: api.Log.PrevisitAuditAction,
    previsitLog: api.Log.PrevisitAction,
  ) => {
    api.client.Previsit.createPrevisitLog({
      auditLog,
      previsitLog,
      authenticationCode,
    });
    setShowModal(false);
  };

  return (
    <>
      {timeSlots.map((slot) => {
        return (
          <Button
            data-testid="time-slot-button"
            key={slot.id}
            onClick={() => {
              setShowModal(true);
              setSelectedSlot(slot);
              api.client.Previsit.createPrevisitLog({
                auditLog:
                  api.Log.PrevisitAuditAction
                    .PatientPrevisitSchedulingSlotConfirmationModalTriggered,
                previsitLog:
                  api.Log.PrevisitAction
                    .SchedulingSlotConfirmationModalTriggered,
                authenticationCode,
              });
            }}
            className={styles.AppointmentButton}
            children={
              timezone
                ? moment(slot.startTime).tz(timezone).format(TIME_OF_DAY_FORMAT)
                : moment(slot.startTime).format(TIME_OF_DAY_FORMAT)
            }
            variant="primary"
            size="small"
          />
        );
      })}
      {!!selectedSlot && (
        <TimeSlotConfirmationModal
          show={showModal}
          selectedSlot={selectedSlot}
          timezone={timezone}
          onAppointmentSelected={onAppointmentSelected}
          onCloseModal={closeModal}
        />
      )}
    </>
  );
};

export default TimeSlots;
